module.exports = __webpack_public_path__ + "media/images/common/favicon-33d8dbcba33138751f0514c00e806b8d.ico";